import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { GridBackground } from "../EAKCArchitecture/components/GridBackground";
import { StatCounter } from "../shared/StatCounter";
import { COLORS, FONTS, SPRING } from "./constants";

export const Scene01Hook: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // --- "Your team wastes" ---
  const labelOpacity = interpolate(frame, [0, 30], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  // --- Stat counter (appears frame 30) ---
  const statOpacity = spring({
    frame: frame - 30,
    fps,
    config: SPRING.snappy,
  });

  // --- "searching for information" ---
  const searchOpacity = interpolate(frame, [60, 90], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  // --- Subtext at frame 200 ---
  const subOpacity = interpolate(frame, [200, 230], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  // --- Fade out everything 380-450 ---
  const fadeOut = interpolate(frame, [380, 450], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill>
      <GridBackground />

      <AbsoluteFill style={{ opacity: fadeOut }}>
        {/* "Your team wastes" */}
        <div
          style={{
            position: "absolute",
            top: 380,
            left: 0,
            right: 0,
            textAlign: "center",
            fontFamily: FONTS.body,
            fontSize: 36,
            color: COLORS.textSecondary,
            opacity: labelOpacity,
          }}
        >
          Your team wastes
        </div>

        {/* Stat counter: "5 hours/week" */}
        <div
          style={{
            position: "absolute",
            top: 420,
            left: 0,
            right: 0,
            display: "flex",
            justifyContent: "center",
            opacity: statOpacity,
          }}
        >
          <StatCounter
            value={5}
            suffix=" hours/week"
            label=""
            color={COLORS.accentTeal}
            delay={30}
            fontSize={96}
            duration={60}
          />
        </div>

        {/* "searching for information" */}
        <div
          style={{
            position: "absolute",
            top: 540,
            left: 0,
            right: 0,
            textAlign: "center",
            fontFamily: FONTS.body,
            fontSize: 36,
            color: COLORS.textSecondary,
            opacity: searchOpacity,
          }}
        >
          searching for information
        </div>

        {/* Subtext */}
        <div
          style={{
            position: "absolute",
            top: 620,
            left: 0,
            right: 0,
            textAlign: "center",
            fontFamily: FONTS.body,
            fontSize: 20,
            color: COLORS.textMuted,
            opacity: subOpacity,
          }}
        >
          That's one full month lost per person, per year
        </div>

      </AbsoluteFill>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
